import {
    GeneralMobile1,
    GeneralMobile2,
    AIPoweredMobile,
    InstantQuestion1,
    InstantQuestion2,
    Concept1,
    Concept2,
    Concept3,
    Concept4,
    Concept5,
    Concept6,
    Personalized1,
    Personalized2,
    Interactive1,
    Interactive2,
    MBVocabulary1,
    MBVocabulary2,
    ConnectingConcepts1,
    ConnectingConcepts2,
    Summarization1,
    Summarization2,
    ActiveRecall1,
    ActiveRecall2,
    AvailabilityMB,
} from "../assets/images/image";
import { AnimatePresence, motion } from "framer-motion";
const mbImages: any = [
    {
        index: 1,
        img: [GeneralMobile1, GeneralMobile2]
    },
    {
        index: 2,
        img: [AIPoweredMobile]
    },
    {
        index: 3,
        img: [InstantQuestion1, InstantQuestion2]
    },
    {
        index: 4,
        img: [Concept1, Concept2, Concept3, Concept4, Concept5, Concept6]
    },
    {
        index: 5,
        img: [Personalized1, Personalized2]
    },
    {
        index: 6,
        img: [Interactive1, Interactive2]
    },
    {
        index: 7,
        img: [MBVocabulary1, MBVocabulary2]
    },
    {
        index: 8,
        img: [ConnectingConcepts1, ConnectingConcepts2]
    },
    {
        index: 9,
        img: [Summarization1, Summarization2]
    },
    {
        index: 10,
        img: [ActiveRecall1, ActiveRecall2]
    },
    {
        index: 11,
        img: [AvailabilityMB]
    },
];
const AIMobileComponent = ({ indexChoose }: { indexChoose: number }) => {
    if (indexChoose === 0) {
        return <motion.div className="ms-10 me-10">
            <div className="text-[24px] w-full text-center">
                <span className="text-[#484848] font-bold mb-2 text-center ">
                    General
                </span>
            </div>
            <img src={mbImages[indexChoose].img[0]} alt="" className={`w-full h-full mt-5`} />
            <div className="text-[14px] py-10">
                <span className="text-gray-700 text-lg font-normal mb-2">
                    Think of your AI Companion as the ultimate study buddy:
                </span>
                <ul className="list-none pl-0">
                    <li className="flex items-start">
                        <span className="font-normal text-[#7A7A7A] italic">
                            →Always ready <span className="underline">to break down tricky concepts</span>, answer questions, and guide you through your learning journey. Whether you're <span className="underline">tackling homework, prepping for exams,</span> or just curious about the world, it's like having a tutor on demand 24/7, <span className="font-bold">helping you level up anytime, anywhere.</span>
                        </span>
                    </li>
                </ul>
            </div>
            <img src={mbImages[indexChoose].img[1]} alt="" className={`w-full h-full`} />
        </motion.div>
    } else if (indexChoose === 1) {
        return <motion.div className="ms-10 me-10">
            <div className="text-[24px] w-full text-center">
                <span className="text-[#484848] font-bold mb-2 text-center ">
                    AI-Powered Creation Stack of Flashcards
                </span>
            </div>
            <img src={mbImages[indexChoose].img[0]} alt="" className={`w-full h-full mt-5`} />
        </motion.div>
    } else if (indexChoose === 2) {
        return <motion.div className="ms-10 me-10">
            <div className="text-[24px] w-full text-center">
                <span className="text-[#484848] font-bold mb-2 text-center ">
                    Instant Question Answering
                </span>
            </div>
            <div className="text-[14px] w-full text-left mt-4 mb-5">
                <span className="font-normal text-[17px] text-[#484848]">
                    <span className="font-bold text-[24px]">Get immediate explanations</span> and <span className="font-bold text-[24px]">clarify doubts</span> t leaving your study flow.
                </span>
            </div>
            <img src={mbImages[indexChoose].img[0]} alt="" className={`w-full h-full p-3`} />
            <img src={mbImages[indexChoose].img[1]} alt="" className={`w-full h-full p-3`} />
        </motion.div>
    } else if (indexChoose === 3) {
        return <motion.div className="ms-10 me-10">
            <div className="text-[24px] w-full text-center">
                <span className="text-[#484848] font-bold mb-2 text-center ">
                    Concept Clarification & Elaboration
                </span>
            </div>
            <div className="text-[14px] w-full text-left mt-4 mb-5">
                <span className="font-normal text-[17px] text-[#484848]">
                    The AI Companion <span className="font-bold text-[24px] text-green-500">can break down difficult concepts into easy-to-understand terms</span> and provide additional examples.
                </span>
            </div>
            <img src={mbImages[indexChoose].img[0]} alt="" className={`w-full h-full p-1`} />
            <img src={mbImages[indexChoose].img[1]} alt="" className={`w-full h-full p-1`} />
            <img src={mbImages[indexChoose].img[2]} alt="" className={`w-full h-full p-1`} />
            <img src={mbImages[indexChoose].img[3]} alt="" className={`w-full h-full p-1`} />
            <img src={mbImages[indexChoose].img[4]} alt="" className={`w-full h-full p-1`} />
            <img src={mbImages[indexChoose].img[5]} alt="" className={`w-full h-full p-1`} />
        </motion.div>
    } else if (indexChoose === 4) {
        return <motion.div className="ms-10 me-10">
            <div className="text-[24px] w-full text-center">
                <span className="text-[#484848] font-bold mb-2 text-center ">
                    Personalized Study Guidance & Tips
                </span>
            </div>
            <div className="text-[24px] w-full text-left mt-4 mb-5">
                <span className="font-normal text-[24px] text-[#484848]">
                    <span className="font-bold italic">Learn Smarter</span><br /> not <span className="text-[17px] font-bold text-gray-300">Harder</span>
                </span>
            </div>
            <div className="text-[17px] w-full text-left mt-4 mb-5">
                <span className="font-normal text-[#484848]">
                    <span className="font-bold">The AI analyzes your progress and provides tailored study tips,</span> suggesting optimal review times and areas to focus on.
                </span>
            </div>
            <img src={mbImages[indexChoose].img[0]} alt="" className={`w-full h-full p-1`} />
            <img src={mbImages[indexChoose].img[1]} alt="" className={`w-full h-full p-1`} />
        </motion.div>
    } else if (indexChoose === 5) {
        return <motion.div className="ms-10 me-10">
            <div className="text-[24px] w-full text-center">
                <span className="text-[#484848] font-bold mb-2 text-center ">
                    Interactive Quizzing & Practice
                </span>
            </div>
            <div className="w-full text-left mt-4 mb-5">
                <span className="font-normal text-[24px] text-[#484848]">
                    Test<span className="font-bold"> Your Understanding Anytime</span>
                </span>
            </div>
            <div className="text-[17px] w-full text-left mt-4 mb-5">
                <span className="font-normal text-[#484848]">
                    The <span className="font-bold">AI can generate quizzes</span> on demand, providing instant feedback and helping you <span className="font-bold">identify knowledge gaps.</span>
                </span>
            </div>
            <img src={mbImages[indexChoose].img[0]} alt="" className={`w-full h-full p-1`} />
            <img src={mbImages[indexChoose].img[1]} alt="" className={`w-full h-full p-1`} />
        </motion.div>
    } else if (indexChoose === 6) {
        return <motion.div className="ms-10 me-10">
            <div className="text-[24px] w-full text-center">
                <span className="text-[#484848] font-bold mb-2 text-center ">
                    Vocabulary & Definition Support
                </span>
            </div>
            <div className="w-full text-left mt-4 mb-5">
                <span className="font-normal text-[24px] text-[#484848]">
                    Test<span className="font-bold"> Your Understanding Anytime</span>
                </span>
            </div>
            <div className="text-[17px] w-full text-left mt-4 mb-5">
                <span className="font-normal text-[#484848]">
                    The AI Companion provides <span className="font-bold">quick definitions, synonyms,</span> and <span className="font-bold">context</span> for any term within your flashcards.
                </span>
            </div>
            <img src={mbImages[indexChoose].img[0]} alt="" className={`w-full h-full p-1`} />
            <img src={mbImages[indexChoose].img[1]} alt="" className={`w-full h-full p-1`} />
        </motion.div>
    } else if (indexChoose === 7) {
        return <motion.div className="ms-10 me-10">
            <div className="text-[24px] w-full text-center">
                <span className="text-[#484848] font-bold mb-2 text-center ">
                    Connecting Concepts
                </span>
            </div>
            <div className="w-full text-left mt-4 mb-5">
                <span className="font-normal text-[24px] text-[#484848]">
                    <span className="font-bold">Build a Deeper Understanding by seeing how different ideas relate. </span>
                </span>
            </div>
            <div className="text-[17px] w-full text-left mt-4 mb-5">
                <span className="font-normal text-[#484848]">
                    The AI can highlight connections between flashcards and topics.
                </span>
            </div>
            <img src={mbImages[indexChoose].img[0]} alt="" className={`w-full h-full p-1`} />
            <img src={mbImages[indexChoose].img[1]} alt="" className={`w-full h-full p-1`} />
        </motion.div>
    } else if (indexChoose === 8) {
        return <motion.div className="ms-10 me-10">
            <div className="text-[24px] w-full text-center">
                <span className="text-[#484848] font-bold mb-2 text-center ">
                    Summarization of Complex Topics
                </span>
            </div>
            <div className="w-full text-left mt-4 mb-5">
                <span className="font-normal text-[24px] text-[#484848]">
                    <span className="underline">Quickly Grasp </span><span className="font-bold italic">the core ideas</span> of large flashcard bundles.
                </span>
            </div>
            <div className="text-[17px] w-full text-left mt-4 mb-5">
                <span className="font-normal text-[#484848]">
                    The AI Companion can <span className="font-bold">summarize key concepts</span> for efficient review.
                </span>
            </div>
            <img src={mbImages[indexChoose].img[0]} alt="" className={`w-full h-full p-1`} />
            <img src={mbImages[indexChoose].img[1]} alt="" className={`w-full h-full p-1`} />
        </motion.div>
    } else if (indexChoose === 9) {
        return <motion.div className="ms-10 me-10">
            <div className="text-[24px] w-full text-center">
                <span className="text-[#484848] font-bold mb-2 text-center ">
                    Active Recall Prompts
                </span>
            </div>
            <div className="w-full text-left mt-4 mb-5">
                <span className="font-normal text-[24px] text-[#484848]">
                    Train your memory <span className="font-bold">More Effectively</span>
                </span>
            </div>
            <div className="text-[17px] w-full text-left mt-4 mb-5">
                <span className="font-normal text-[#484848]">
                    The AI -Companion can prompt you to recall information before revealing the answer, <span className="font-bold">strengthening retention.</span>
                </span>
            </div>
            <img src={mbImages[indexChoose].img[0]} alt="" className={`w-full h-full p-1`} />
            <img src={mbImages[indexChoose].img[1]} alt="" className={`w-full h-full p-1`} />
        </motion.div>
    } else if (indexChoose === 10) {
        return <motion.div className="ms-10 me-10">
            <div className="text-[24px] w-full text-center">
                <span className="text-[#484848] font-bold mb-2 text-center ">
                    24/7 Availability
                </span>
            </div>
            <div className="w-full text-left mt-4 mb-5">
                <span className="font-normal text-[24px] text-[#484848]">
                    Your <span className="font-bold text-yellow-300">PERSONAL TUTOR</span> is <span className="font-bold">always available</span>, whenever and wherever you need help with your studies.
                </span>
            </div>
            <img src={mbImages[indexChoose].img[0]} alt="" className={`w-full h-full p-1`} />
        </motion.div>
    } else {
        return <></>
    }
}
export default AIMobileComponent